export default __webpack_public_path__ + "static/media/buddweiser.f3baebb6.svg";